module.exports = __webpack_public_path__ + "static/img/banner-3.9e6e68d1.jpg";